export const dataHooks = {
  root: 'error-cone-page-root',
  tryAgainButton: 'error-cone-page-try-again-button',
  additionalActionButton: 'error-cone-page-additional-action-button',
};
